export const BANNER_TEXT_BOLD = 'This is a preview. '
export const BANNER_TEXT =
  'Close this preview and click the Teach button on the Unit page to teach the lesson and have your progress saved.'
export const DATA_TEST_ID = 'prep-banner'
